import React from 'react';
import SkylineImg from '../img/skyline-home.jpg';
import Splash from './Splash';

const style = {
  backgroundImage: `url(${SkylineImg})`
}

const HomeSplash = () => (
  <Splash style={style} title="Welcome to OLLIE"/>
)

export default HomeSplash;


// WEBPACK FOOTER //
// ./src/components/HomeSplash.js